import { 
  Target, TrendingUp, Shield, Smile, Zap, Maximize, DollarSign, 
  Users, Heart, CheckCircle, Monitor, Video, BookOpen, MessageCircle, 
  Play, Layers, Brain, GraduationCap, BarChart3, Trophy, Rocket, 
  FileText, Crown, Star, Compass, Bookmark, Share2, Calendar, Award
} from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL;

// Badge icon mapping
export const BADGE_ICONS = {
  'rocket': Rocket,
  'bar-chart': BarChart3,
  'trophy': Trophy,
  'crown': Crown,
  'bookmark': Bookmark,
  'layers': Layers,
  'compass': Compass,
  'star': Star,
  'file-text': FileText,
  'share-2': Share2,
  'calendar': Calendar,
  'award': Award
};

// Badge color classes
export const BADGE_COLORS = {
  blue: { bg: 'bg-blue-100', text: 'text-blue-600', ring: 'ring-blue-500' },
  green: { bg: 'bg-emerald-100', text: 'text-emerald-600', ring: 'ring-emerald-500' },
  yellow: { bg: 'bg-yellow-100', text: 'text-yellow-600', ring: 'ring-yellow-500' },
  purple: { bg: 'bg-purple-100', text: 'text-purple-600', ring: 'ring-purple-500' },
  teal: { bg: 'bg-teal-100', text: 'text-teal-600', ring: 'ring-teal-500' },
  indigo: { bg: 'bg-indigo-100', text: 'text-indigo-600', ring: 'ring-indigo-500' },
  orange: { bg: 'bg-orange-100', text: 'text-orange-600', ring: 'ring-orange-500' },
  amber: { bg: 'bg-amber-100', text: 'text-amber-600', ring: 'ring-amber-500' },
  slate: { bg: 'bg-slate-100', text: 'text-slate-600', ring: 'ring-slate-500' },
  pink: { bg: 'bg-pink-100', text: 'text-pink-600', ring: 'ring-pink-500' },
  cyan: { bg: 'bg-cyan-100', text: 'text-cyan-600', ring: 'ring-cyan-500' }
};

// Template color classes
export const TEMPLATE_COLORS = {
  rose: { bg: 'bg-rose-50', border: 'border-rose-200', icon: 'bg-rose-100 text-rose-600', hover: 'hover:border-rose-400' },
  emerald: { bg: 'bg-emerald-50', border: 'border-emerald-200', icon: 'bg-emerald-100 text-emerald-600', hover: 'hover:border-emerald-400' },
  blue: { bg: 'bg-blue-50', border: 'border-blue-200', icon: 'bg-blue-100 text-blue-600', hover: 'hover:border-blue-400' },
  amber: { bg: 'bg-amber-50', border: 'border-amber-200', icon: 'bg-amber-100 text-amber-600', hover: 'hover:border-amber-400' },
  red: { bg: 'bg-rose-50', border: 'border-rose-200', icon: 'bg-rose-100 text-rose-600', hover: 'hover:border-rose-400' },
  purple: { bg: 'bg-purple-50', border: 'border-purple-200', icon: 'bg-purple-100 text-purple-600', hover: 'hover:border-purple-400' },
};

// Icon mapping for KPIs
export const KPI_ICONS = {
  'trending-up': TrendingUp,
  'check-circle': CheckCircle,
  'shield': Shield,
  'smile': Smile,
  'zap': Zap,
  'maximize': Maximize,
  'dollar-sign': DollarSign,
  'target': Target,
  'users': Users,
  'heart': Heart
};

// Modality icons
export const MODALITY_ICONS = {
  'on_the_job': Brain,
  'simulation': Video,
  'in_person_ilt': GraduationCap,
  'blended': Layers,
  'peer_learning': MessageCircle,
  'virtual_ilt': Monitor,
  'microlearning': Play,
  'self_paced_elearning': BookOpen
};
